import React from 'react';

import './css/sessionExpiryModal.css';

type Props = {
  open: boolean;
  expiresAtMs: number;
  onContinue: () => void;
  onLogoutNow: () => void;
  loading?: boolean;
  timeLeftSec: number;
  warningWindowSec: number;
};

export default function SessionExpiryModal({ open, expiresAtMs, onContinue, onLogoutNow, loading, timeLeftSec, warningWindowSec }: Props) {
  if (!open) return null;

  const safeLeftSec = Math.max(0, timeLeftSec);
  const minutes = Math.floor(safeLeftSec / 60);
  const seconds = safeLeftSec % 60;
  const denom = Math.max(1, warningWindowSec || 1);
  const progressPct = Math.max(0, Math.min(100, (safeLeftSec / denom) * 100));

  return (
    <div className="sem-overlay" role="dialog" aria-modal="true" aria-label="Session expiring">
      <div className="sem-modal">
        <div className="sem-header">
          <div className="sem-headerContent">
            <div className="sem-icon" aria-hidden="true">
              <svg viewBox="0 0 20 20" width="24" height="24">
                <path
                  fillRule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div>
              <div className="sem-title">Session Expiring Soon</div>
              <div className="sem-subtitle">You will be logged out automatically</div>
            </div>
          </div>
        </div>

        <div className="sem-body">
          <div className="sem-countdownRow">
            <div className="sem-timerCircle">
              {minutes}:{String(seconds).padStart(2, '0')}
            </div>
            <div className="sem-message">Time remaining until automatic logout</div>
          </div>

          <div className="sem-progressBar" aria-hidden="true">
            <div className="sem-progressFill" style={{ width: `${progressPct}%` }} />
          </div>

          <div className="sem-actions">
            <button
              type="button"
              onClick={onContinue}
              disabled={!!loading}
              className={`sem-btn sem-btn-primary${loading ? ' sem-btn-loading' : ''}`}
            >
              {loading ? 'Refreshing...' : 'Continue Session'}
            </button>
            <button type="button" onClick={onLogoutNow} disabled={!!loading} className="sem-btn sem-btn-secondary">
              Logout Now
            </button>
          </div>
        </div>

        <div className="sem-footer">
          For security reasons, inactive sessions are automatically terminated after the countdown expires
        </div>
      </div>
    </div>
  );
}
